import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Menu from './Menu';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css'

const Root = document.getElementById('root');
const Container = document.createElement("div");
Container.style.position = "relative";
Container.style.overflow = "hidden";
Container.style.width = "100%";
Container.style.height = "100vh";
if ((window.innerHeight < 700)&&(window.innerWidth < 700)) {
  const Header = document.createElement("div");
  Header.classList.add("map-header")
  Header.innerHTML = `<div>Area 80 Manitoba Public</div><a class="map-fullscreen-button" href="${window.location.href}" target="_blank"></a>`
  Container.appendChild(Header);
  Container.style.height = "calc(100vh - 55px)";
}
const MapRoot = document.createElement("div");
MapRoot.style.width = "100%";
MapRoot.style.height = "100%";
const MenuRoot = document.createElement("div");
MenuRoot.style.width = "100%";
MenuRoot.style.height = "100%";
Container.appendChild(MapRoot);
Container.appendChild(MenuRoot);
Root.appendChild(Container);
const mapRoot = ReactDOM.createRoot(MapRoot);
const menuRoot = ReactDOM.createRoot(MenuRoot);

let context = {};

menuRoot.render(
  <React.StrictMode>
    <Menu context={context}/>
  </React.StrictMode>
); //This is to avoid the flickering issue found with the map, due to the whole map reloading each time.
mapRoot.render(
  <React.StrictMode>
    <App context={context}/>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
